module.exports = __webpack_public_path__ + "e24780c63322e5b46d347a4a14f446dc.png";